import React from 'react'
import { arrayOf, object } from 'prop-types'
import { toast, Slide } from 'react-toastify';
import VerticalNameChildren from '../../../components/library/layout/VerticalNameChildren'
import DateTime from '../../../components/library/common/DateTime'
import EmdashText from '../../../components/library/common/EmdashText'
import HrbTranslate from '../../../components/language/HrbTranslate'
import CollapsibleCardContent from '../../../components/library/stacking-collapsible-cards/CollapsibleCardContent'
import CollapsibleCardHeader from '../../../components/library/stacking-collapsible-cards/CollapsibleCardHeader'
import StackableCardWrapper from '../../../components/library/stacking-collapsible-cards/StackableCardWrapper'
import lang from '../../../components/language/services/Lang';
import Button from '../../../components/library/buttons/Button';
import { FileCopyOutlined } from '@mui/icons-material';

const ExpertReviewCard = ({ expertReview, taxYear }) => {
    const onCopyJsonClick = (e) => {
        const el = document.createElement('textarea');
        el.value = expertReview.content;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        toast.success(lang.getCurrentValue('ToastLabels.CopiedToClipboard'),
            { className: 'black-background-toast', position: "bottom-left", autoClose: 5000, transition: Slide, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true });
    }
    
    return (
        <StackableCardWrapper className='light-grey card-expert-review'>
            <CollapsibleCardHeader>
                <div className='column is-9'>
                    <h4><HrbTranslate text={ taxYear > 2021 ? 'ReturnInfo.Headers.ExpertHelp' : 'ReturnInfo.Headers.ExpertReview' } /></h4>
                </div>
            </CollapsibleCardHeader>
            <CollapsibleCardContent className='py-3'>
                <div className='column is-4'>
                    <Button elementId='btn-copy-json' labelKey='ReturnInfo.Labels.CopyMostRecentJson' buttonStyles='secondary' onClick={onCopyJsonClick} textLast='true'><FileCopyOutlined id='launch-tpsc-icon' /></Button>
                </div>
                <div className='column is-5'>
                    <VerticalNameChildren textKey='ReturnInfo.Labels.LastModified'>
                        {expertReview.lastModified ?
                            <p className='p1 bold-weight'><DateTime value={expertReview.lastModified} dateAndTime /></p> :
                            <p className='p1 bold-weight'><EmdashText /></p>}
                    </VerticalNameChildren>
                </div>
                <div className='column is-3'>                    
                </div>
            </CollapsibleCardContent>
        </StackableCardWrapper>
    );
}

ExpertReviewCard.propTypes = {
    paymentInfo: arrayOf(object),
    expertReview: object
}

export default ExpertReviewCard
